<template>
    <div>
        <auth-container :page="page">
            <h2 class="mb-4">TWDB Report</h2>

            <b-table striped responsive table-class="border-bottom table-grid" sticky-header="60vh"
                     small show-empty
                     :items="data"
                     :fields="table.fields">
                <template #table-busy>
                    <div class="text-center my-4">
                        <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
                    </div>
                </template>
                <template #empty>
                    <div class="my-2 mx-2"><em>No data found.</em></div>
                </template>
            </b-table>

            <fixed-action-bar>
                <json-to-csv :json-data="data" filename="srreports_twdb" class="mr-2" />
                <router-link to="/sr/agreements/fed" class="btn btn-success mr-2">
                    View All Federal Agreements
                </router-link>
            </fixed-action-bar>
        </auth-container>
    </div>
</template>

<script>
    export default {
        name: 'SrReportTwdb',
        data() {
            return {
                page: {
                    errors: [],
                    loading: true,
                    showLogin: false,
                },
                data: [],
                table: {
                    fields: [
                        { key: 'paFederalGrantNumber', label: 'PA/Federal Grant #', sortable: true },
                        { key: 'originalAwardAmount', label: 'Original Award Amount', sortable: true, formatter: (value) => { return this.money(value) } },
                        { key: 'awardPostAmendments', label: 'Award Post Amendments', sortable: true, formatter: (value) => { return this.money(value) } },
                        { key: 'awardStartDate', label: 'Award Start Date', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
                        { key: 'awardEndDate', label: 'Award End Date', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
                        { key: 'expendedAmount', label: 'Expended Amount', sortable: true, formatter: (value) => { return this.money(value) } },
                        { key: 'awardBalance', label: 'Award Balance', sortable: true, formatter: (value) => { return this.money(value) } },
                    ],
                }
            }
        },
        async created() {
            await this.get();
        },
        watch: {
            '$route': 'get',
        },
        methods: {
            async get() {
                this.page.errors = [];
                this.page.loading = true;

                try {
                    const response = await this.$http.get(`srreports/twdb`, this.getTokenHeader());
                    this.log(response.data);
                    this.data = response.data;
                } catch (error) {
                    if (this.isApiUnauthorized(error)) this.page.showLogin = true;
                    else this.page.errors = this.logError(error);
                }

                this.page.loading = false;
            },
        },
    }
</script>